<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.dense" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="dense" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.showFileIcon" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="showFileIcon" /><!--
          --><checkbox label-size="xs" disabled :icon-color="$root.$colors.primary" :label="$lang.checkboxes" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="checkboxes" />
        </test-toolbar>
      </flex-col>
      <template v-if="treeview">
        <flex-col :span="12" sm24 equal-height>
          <card full-height>
            <card-text>
              <treeview @node-click="onNodeClick" :dense="dense" :checkboxes="checkboxes" :items="treeview" :show-file-icon="showFileIcon" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" />
            </card-text>
          </card>
        </flex-col>
        <flex-col :span="12" sm24 equal-height>
          <card full-height>
            <card-text>
              <treeview @node-click="onNodeClick" :dense="dense" :checkboxes="checkboxes" :items="treeview" :show-file-icon="showFileIcon" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" folder-open="chevron-down" folder-closed="chevron-right" />
            </card-text>
          </card>
        </flex-col>
        <flex-col :span="12" sm24 equal-height>
          <card full-height>
            <card-text>
              <treeview @node-click="onNodeClick" :dense="dense" :checkboxes="checkboxes" :items="treeview" :show-file-icon="showFileIcon" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" folder-open="minus-box" folder-closed="plus-box" />
            </card-text>
          </card>
        </flex-col>
        <flex-col :span="12" sm24 equal-height>
          <card full-height>
            <card-text>
              <treeview @node-click="onNodeClick" :dense="dense" :checkboxes="checkboxes" :items="treeview" :show-file-icon="showFileIcon" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" folder-open="menu-down" folder-closed="menu-right" />
            </card-text>
          </card>
        </flex-col>
      </template>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageTreeview',
  mixins: [
    methods
  ],
  data () {
    return {
      treeview: null,
      dense: false,
      checkboxes: false,
      showFileIcon: false
    }
  },
  mounted () {
    this.getExternalData('treeview.json', 'treeview')
  },
  methods: {
    onNodeClick ($event) {
      this.log('node-click', 'treeview', $event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/treeview.vue